import ApplicationComponent from "legacy/ApplicationComponent"
import DatePicker from "legacy/DatePicker"
import FormGroup from "legacy/FormGroup"
import LegacyExportButton from "legacy/reports/ExportButton"
import { validatorFactory } from "legacy/validatorFactory"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

class Export extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      startDate: moment(props.startDate, this.props.dateFormat || "YYYY-MM-DD"),
      endDate: moment(props.endDate, this.props.dateFormat || "YYYY-MM-DD"),
      startDateLabel: props.startDateLabel || "Start Date",
      endDateLabel: props.endDateLabel || "End Date",
      showLegacyReportConfirmation: true,
    }
    if (props.selectOptions) {
      this.state.selectValue = Object.keys(props.selectOptions)[0]
    }
    this.validator = validatorFactory()
    this.validator.showMessages()

    // Bind methods
    this.reportType = this.reportType.bind(this)
    this.amplitudeEvent = this.amplitudeEvent.bind(this)
    this.label = this.label.bind(this)
    this.optionalSelect = this.optionalSelect.bind(this)
    this.startDate = this.startDate.bind(this)
    this.endDate = this.endDate.bind(this)
    this.renderIntercomLink = this.renderIntercomLink.bind(this)
    this.renderStartDatePicker = this.renderStartDatePicker.bind(this)
    this.renderEndDatePicker = this.renderEndDatePicker.bind(this)
    this.endDateValidation = this.endDateValidation.bind(this)
    this.renderMultiPropertyCheckbox =
      this.renderMultiPropertyCheckbox.bind(this)
    this.renderExportForm = this.renderExportForm.bind(this)
    this.renderLegacyReportConfirmation =
      this.renderLegacyReportConfirmation.bind(this)
  }

  reportType() {
    if (this.props.selectOptions) {
      return this.state.selectValue
    }
  }

  amplitudeEvent() {
    if (this.props.selectOptions) {
      return this.props.selectOptions[this.state.selectValue].amplitudeEvent
    } else {
      return this.props.amplitudeEvent
    }
  }

  label() {
    return this.props.label || "Export Type"
  }

  optionalSelect() {
    if (this.props.selectOptions) {
      return (
        <div className="col-sm-4">
          <FormGroup
            inputType="select"
            label={this.label()}
            name="selectValue"
            value={this.state.selectValue}
            onChange={this.handleInputChange}
          >
            {Object.entries(this.props.selectOptions).map(([key, options]) => (
              <option key={key} value={key}>
                {options.name}
              </option>
            ))}
          </FormGroup>
        </div>
      )
    }
  }

  startDate() {
    if (this.props.startDateRangeCutoff) {
      return moment(
        this.props.startDateRangeCutoff,
        this.props.dateFormat || "YYYY-MM-DD"
      ).format(this.props.dateFormat || "MM/DD/YYYY")
    }
  }

  endDate() {
    let maybeEndDate
    if (
      this.props.selectOptions &&
      this.props.selectOptions[this.state.selectValue].endDateRangeCutoff
    ) {
      maybeEndDate =
        this.props.selectOptions[this.state.selectValue].endDateRangeCutoff
    } else if (this.props.endDateRangeCutoff) {
      maybeEndDate = this.props.endDateRangeCutoff
    }

    if (maybeEndDate) {
      return moment(maybeEndDate, this.props.dateFormat || "YYYY-MM-DD").format(
        this.props.dateFormat || "MM/DD/YYYY"
      )
    } else {
      return null
    }
  }

  renderIntercomLink() {
    const { intercomCopy, intercomHref } = this.props

    return (
      intercomCopy &&
      intercomHref && (
        <a
          className="row form-row"
          href={intercomHref}
          target="_blank"
          rel="noopener noreferrer"
        >
          {intercomCopy}
        </a>
      )
    )
  }

  renderStartDatePicker() {
    if (this.props.noStartDate) {
      return null
    } else {
      return (
        <div
          className={`${this.props.selectOptions ? "col-sm-4" : "col-sm-6"}`}
        >
          <div className="form-group">
            <label htmlFor="startDate">{this.state.startDateLabel}</label>
            <div className="form-control-with-icon">
              <i className="icon icon-calendar form-control-icon-left" />
              <DatePicker
                name="startDate"
                setParentState={(startDate) =>
                  this.setState({
                    startDate: moment(
                      startDate,
                      this.props.dateFormat || "MM/DD/YYYY"
                    ),
                  })
                }
                value={this.state.startDate.format(
                  this.props.dateFormat || "MM/DD/YYYY"
                )}
                orientation="top"
                dateFormat={this.props.datepickerFormat}
                dateMaxView={this.props.dateMaxView}
                dateMinView={this.props.dateMinView}
                startDate={this.startDate()}
                endDate={this.endDate()}
                id="startDate"
              />
            </div>
            {this.validator.message(
              "start date",
              this.state.startDate,
              "required"
            )}
          </div>
        </div>
      )
    }
  }

  renderEndDatePicker() {
    return (
      <div className={`${this.props.selectOptions ? "col-sm-4" : "col-sm-6"}`}>
        <div className="form-group">
          <label htmlFor="endDate">{this.state.endDateLabel}</label>
          <div className="form-control-with-icon">
            <i className="icon icon-calendar form-control-icon-left" />
            <DatePicker
              name="endDate"
              setParentState={(endDate) =>
                this.setState({
                  endDate: moment(
                    endDate,
                    this.props.dateFormat || "MM/DD/YYYY"
                  ),
                })
              }
              value={this.state.endDate.format(
                this.props.dateFormat || "MM/DD/YYYY"
              )}
              orientation="top"
              dateFormat={this.props.datepickerFormat}
              dateMaxView={this.props.dateMaxView}
              dateMinView={this.props.dateMinView}
              startDate={this.startDate()}
              endDate={this.endDate()}
              id="endDate"
            />
          </div>
          {this.endDateValidation()}
        </div>
      </div>
    )
  }

  endDateValidation() {
    if (this.props.noStartDate) {
      return null
    } else {
      return this.validator.message(
        "end date",
        this.state.endDate,
        ["required", { after_or_equal: this.state.startDate }],
        {
          messages: { default: "End date must be on or after the start date." },
        }
      )
    }
  }

  renderMultiPropertyCheckbox() {
    return (
      this.props.multiPropertyEligible && (
        <div>
          <hr />
          <FormGroup
            inputType="checkbox"
            onChange={this.handleInputChange}
            name="multiPropertyExport"
            label="Include all marina group properties"
          />
        </div>
      )
    )
  }

  renderExportForm() {
    return (
      <div>
        {this.props.descriptionHtml ? (
          <div
            dangerouslySetInnerHTML={{ __html: this.props.descriptionHtml }}
          />
        ) : (
          <div style={{ lineHeight: 1.8 }}>{this.props.description}</div>
        )}
        {this.renderIntercomLink()}
        {this.props.additionalDescription && (
          <div style={{ lineHeight: 1.8 }}>
            {this.props.additionalDescription}
          </div>
        )}
        <hr />
        <div className="row form-row">
          {this.optionalSelect()}
          {this.renderStartDatePicker()}
          {this.renderEndDatePicker()}
        </div>
        <LegacyExportButton
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          multiPropertyExport={this.state.multiPropertyExport}
          reportType={this.reportType()}
          amplitudeEvent={this.amplitudeEvent()}
          dateFormat={this.props.dateFormat}
          url={this.props.url}
          validator={this.validator}
        />
        {this.renderMultiPropertyCheckbox()}
      </div>
    )
  }

  renderLegacyReportConfirmation() {
    const { newAccountingReportPath } = this.props
    const {
      legacyReportMessage = "You now have access to the new, all-in-one Accounting Reports.\nThese new reports are accurate, consistent and easy to use.",
    } = this.props

    return (
      <div className="legacy-report-confirmation text-center">
        <div style={{ padding: "0 150px" }}>
          <div className="whitespace-pre-wrap" style={{ marginTop: "60px" }}>
            {legacyReportMessage}
          </div>
          <a
            className="row form-row btn btn-primary bg-blue-600"
            href={newAccountingReportPath}
            style={{ margin: "30px 30px" }}
          >
            Check it out
          </a>
          <div
            className="row form-row cursor-pointer text-blue-600"
            onClick={() =>
              this.setState({ showLegacyReportConfirmation: false })
            }
            style={{ fontWeight: 600, marginBottom: 38 }}
          >
            No, take me to the legacy report.
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { newAccountingReportPath } = this.props
    const { showLegacyReportConfirmation } = this.state

    return newAccountingReportPath && showLegacyReportConfirmation
      ? this.renderLegacyReportConfirmation()
      : this.renderExportForm()
  }
}

Export.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  dateFormat: PropTypes.string,
  startDateLabel: PropTypes.string,
  endDateLabel: PropTypes.string,
  selectOptions: PropTypes.object,
  startDateRangeCutoff: PropTypes.string,
  endDateRangeCutoff: PropTypes.string,
  intercomCopy: PropTypes.string,
  intercomHref: PropTypes.string,
  noStartDate: PropTypes.bool,
  datepickerFormat: PropTypes.string,
  dateMaxView: PropTypes.string,
  dateMinView: PropTypes.string,
  description: PropTypes.node,
  descriptionHtml: PropTypes.string,
  additionalDescription: PropTypes.node,
  multiPropertyEligible: PropTypes.bool,
  newAccountingReportPath: PropTypes.string,
  legacyReportMessage: PropTypes.string,
  label: PropTypes.string,
  amplitudeEvent: PropTypes.string,
  url: PropTypes.string.isRequired,
}

export default Export
